<div mat-dialog-content style="width: 650px;">
   <app-activity-creation-page
     [storeId]="data.storeId"
   ></app-activity-creation-page>
</div>